import apiService from "./api";

const pricingService = {
  // Price history for a restaurant, optionally filtered to a single service
  getRestaurantPricing(restaurantId, params) {
    return apiService.get(`/restaurants/${restaurantId}/pricing`, params);
  },
  // Set a new price (closes/archives the currently active one)
  createRestaurantPrice(restaurantId, payload) {
    return apiService.post(`/restaurants/${restaurantId}/pricing`, payload);
  },
  // Confirm a price carried over from the previous system, without changing the amount
  verifyRestaurantPrice(restaurantId, pricingId) {
    return apiService.patch(`/restaurants/${restaurantId}/pricing/${pricingId}/verify`);
  },
  // Global cross-restaurant worklist of missing/unverified price lists
  getPendingPriceVerification(params) {
    return apiService.get("/pricing/pending-verification", params);
  },
};

export default pricingService;
